import { render } from "./QuestionsList.vue?vue&type=template&id=3bda4086&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"

import "./QuestionsList.vue?vue&type=style&index=0&id=3bda4086&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bda4086"]])

export default __exports__